import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import throttle from 'lodash/throttle';
// import english from 'shared/translations/en.json';
// import moment from 'moment';
import { PATH, FORM_KEYS } from 'shared/constant/index';
import rootReducer from './reducers';
import localState from './localStorage';

const persistedState = localState.loadState();
const {
  ID_PASSPORT,
  CLIENT_DETAILS, PEP, BANK, SOURCE_OF_WEALTH, ASI, CLIENT_PROFILE_FORM,
  FATCA, CRS,
  COUNTRY_TAX,
  AGREEMENT,
  APPLICANT,
} = FORM_KEYS;

const KuwaitCC = {
  name: 'Kuwait',
  dialCode: '+965',
  isoCode: 'KW',
  flag: 'https://cdn.kcak11.com/CountryFlags/countries/kw.svg',
};

/** Add initial states here */
export const initialState = {
  catalogueReducer: {
    data: persistedState?.catalog || [],
    selected: '',
  },
  languageReducer: {
    // language: { locale: 'EN', messages: english },
    language: { locale: ((persistedState && persistedState.language && persistedState.language.locale) || 'EN'), messages: {} },
    translation: {},
  },
  authReducer: {
    phoneNumber: (persistedState && persistedState.auth && persistedState.auth.phoneNumber) || '+965',
    emailAddress: (persistedState && persistedState.auth && persistedState.auth.emailAddress) || '',
    isUserExisting: (persistedState && persistedState.auth && persistedState.auth.isUserExisting) || false,
    token: (persistedState && persistedState.auth && persistedState.auth.token) || null,
    isAuthenticated: false,
    otpTime: null,
    error: null,
    dsUserDetail: (persistedState && persistedState.auth && persistedState.auth.dsUserDetail) || '',
  },
  formOptionReducer: {
    formOptions: (persistedState && persistedState.formOptions) || {},
    isSubmitClicked: false,
  },
  stepsReducer: {
    currentStep: 'step1',
    steps: [
      {
        id: 'step1',
        level: 'Step 1',
        title: 'Phone Number Verification',
        isActive: false,
        isCompleted: true,
        isContinue: null,
      }, {
        id: 'step2',
        level: 'Step 2',
        title: 'ID & Passport',
        isActive: true,
        isCompleted: false,
        isContinue: false,
        pageSource: PATH.ID_PASSPORT,
      }, {
        id: 'step3',
        level: 'Step 3',
        title: 'Personal Information',
        isActive: false,
        isCompleted: false,
        isContinue: false,
        pageSource: PATH.PERSONAL_INFORMATION,
      }, {
        id: 'step4',
        level: 'Step 4',
        title: 'FATCA & CRS Questionnaires',
        isActive: false,
        isCompleted: false,
        isContinue: false,
        pageSource: PATH.FATCA_CRS,
      }, {
        id: 'step5',
        level: 'Step 5',
        title: 'Preview & Signing',
        isActive: false,
        isCompleted: false,
        isContinue: false,
        pageSource: `${PATH.PREVIEW}/crm`,
      }, {
        id: 'step6',
        level: 'Step 6',
        title: 'Final Documentation',
        isActive: false,
        isCompleted: false,
        isContinue: false,
        pageSource: PATH.PAYMENT, // PATH.PRINT_CHECKLIST,
      },
    ],
  },
  applicantRootReducer: {
    applicantReducer: {
      [APPLICANT.APPLICANT_ID]: '',
      [APPLICANT.PHONE_NUMBER]: '',
      [APPLICANT.IS_EMAIL_SENT]: null,
      imarkazRefCode: (persistedState && persistedState.refCode) || '',
      completionDate: null,
      lastLoggedIn: null,
      currentLoggedIn: null,
      latestRefCode: (persistedState && persistedState.latestRefCode) || '',
      productCode: (persistedState && persistedState.productCode) || '',
      proofOfTransfer: null,
      paciFrontStatus: null,
    },
    idPassportReducer: {
      [ID_PASSPORT.FULL_NAME]: '',
      [ID_PASSPORT.IS_WITH_CIVIL_ID]: 'yes',
      [ID_PASSPORT.CIVIL_ID]: '',
      [ID_PASSPORT.PASSPORT_ID]: '',
      [ID_PASSPORT.SELFIE]: '',
      [ID_PASSPORT.CIVIL_ID_FRONT]: '',
      [ID_PASSPORT.CIVIL_ID_BACK]: '',
      [ID_PASSPORT.PASSPORT]: '',
      [ID_PASSPORT.TO_BE_EMAILED]: '',
    },
    personalInformationReducer: {
      clientDetails: {
        [CLIENT_DETAILS.CLIENT_CLASSIFICATION]: '',
        [CLIENT_DETAILS.QUALIFIED_INVESTOR]: [],
        [CLIENT_DETAILS.TYPE_OF_INVESTMENT]: '',
        [CLIENT_DETAILS.PRODUCT]: '',
        [CLIENT_DETAILS.NATIONALITY]: '',
        [CLIENT_DETAILS.DATE_OF_BIRTH]: '',
        [CLIENT_DETAILS.CITY_OF_BIRTH]: '',
        [CLIENT_DETAILS.COUNTRY_OF_BIRTH]: '',
        [CLIENT_DETAILS.OCCUPATION]: '',
        [CLIENT_DETAILS.HOME_ADDRESS]: '',
        [CLIENT_DETAILS.COUNTRY_OF_RESIDENCE]: '',
        [CLIENT_DETAILS.EMAIL_ADDRESS]: '',
        [CLIENT_DETAILS.MOBILE]: (persistedState && persistedState.auth && persistedState.auth.phoneNumber) || '+965',
        [CLIENT_DETAILS.EMPLOYER_BUSINESS_NAME]: '',
        [CLIENT_DETAILS.POSITION]: '',
        [CLIENT_DETAILS.OFFICE_ADDRESS]: '',
        [CLIENT_DETAILS.INVESTMENT_STRATEGY]: [],
        [CLIENT_DETAILS.INVESTED_AMOUNT]: '',
        [CLIENT_DETAILS.ASSET_ALLOCATIONS]: '',
        [CLIENT_DETAILS.INVESTED_UNIT_TO_AMOUNT]: '',
        [CLIENT_DETAILS.BUFFERED_INVESTMENT_UNITS]: '',
        [CLIENT_DETAILS.INVESTMENT_UNIT_TYPE]: '',
        [CLIENT_DETAILS.INVESTMENT_UNITS]: '',
        [CLIENT_DETAILS.ARABIC_FUND_NAME]: '',
        [CLIENT_DETAILS.EN_FUND_NAME]: '',
        [CLIENT_DETAILS.PRODUCT_BANK_DETAILS]: {
          accountName: '',
          accountNo: '',
          bankType: '',
          branch: '',
          currency: '',
          iban: '',
          id: '',
          name: '',
          swift: '',
        },
        [CLIENT_DETAILS.AOA]: '',
      },
      pep: {
        [PEP.IS_PEP]: null,
        [PEP.BENEFICIARIES]: [{
          id: 'pep-1',
          [PEP.NAME]: '',
          [PEP.CURRENT_FORMER_OPTION]: 'Current',
          [PEP.POSITION]: '',
          [PEP.RELATIONSHIP]: '',
        }],
      },
      bankDetails: {
        [BANK.BANK_NAME]: '',
        [BANK.OTHER_BANK_NAME]: '',
        [BANK.DOMICILE_COUNTRY]: '',
        [BANK.ACCOUNT_NAME]: '',
        [BANK.BANK_ACCT_FORMAT]: true,
        [BANK.IBAN]: '',
        [BANK.CURRENCY]: '',
        [BANK.USING_KNET]: 'false',
        [BANK.CARD_INFO]: [
          {
            index: 1,
            lastFourDigits: '',
            expMonth: '',
            expYear: '',
            value: '',
            digitErr: '',
            error: '',
          },
          {
            index: 2,
            lastFourDigits: '',
            expMonth: '',
            expYear: '',
            value: '',
            digitErr: '',
            error: '',
          },
        ],
      },
      sourceOfWealth: {
        [SOURCE_OF_WEALTH.ESTIMATED_WEALTH]: '',
        [SOURCE_OF_WEALTH.WEALTH_FUNDS]: '',
        [SOURCE_OF_WEALTH.OTHER_SOURCE_OF_WEALTH]: '',
        // [SOURCE_OF_WEALTH.NET_ASSETS]: '',
        [SOURCE_OF_WEALTH.NET_INCOME]: '',

        [SOURCE_OF_WEALTH.OTHER_SOURCE_OF_WEALTH_FIELDS]: '', // to be used as key to send all new fields below
        [SOURCE_OF_WEALTH.TOTAL_YRS_EXP]: '',
        [SOURCE_OF_WEALTH.DETAIL_OF_REL]: '',
        [SOURCE_OF_WEALTH.YR_OR_INHERITANCE]: '',
        [SOURCE_OF_WEALTH.APPROX_VAL_OF_INHERITANCE]: '',
        [SOURCE_OF_WEALTH.TYPE_ASSET_MARKET]: '',
        [SOURCE_OF_WEALTH.APPROX_VAL_INV_SAV]: '',
        [SOURCE_OF_WEALTH.DETAIL_OF_BIZ]: '',
        [SOURCE_OF_WEALTH.TYPE_OF_ACT]: '',
        [SOURCE_OF_WEALTH.APPROX_VAL_REV]: '',

        [SOURCE_OF_WEALTH.ESTIMATED_WEALTH_APPROX_VAL]: '',
        [SOURCE_OF_WEALTH.NET_INCOME_APPROX_VAL]: '',
      },
      asi: {
        [ASI.IS_AUTHORITY_TO_DEAL]: '',
        [ASI.POA_HOLDER]: '',
        [ASI.NAME]: '',
        [ASI.ADDRESS]: '',
        [ASI.EMAIL_ADDRESS]: '',
        [ASI.NATIONALITY]: '',
        [ASI.DOB]: '',
        [ASI.OCCUPATION]: '',
        [ASI.POSITION]: '',
        [ASI.COUNTRY_CODE_MOBILE]: KuwaitCC,
        [ASI.MOBILE]: '',
        [ASI.HOME_NUMBER]: '',
        [ASI.COUNTRY_CODE_HOME_NUMBER]: KuwaitCC,
        [ASI.EMPLOYER_BUSINESS_NAME]: '',
        [ASI.RELATIONSHIP_WITH_CLIENT]: '',
        [ASI.IS_AS_US_PERSON]: '',
      },
      clientProfileForm: {
        [CLIENT_PROFILE_FORM.WITH_INVESTMENT_EXP]: '',
        [CLIENT_PROFILE_FORM.GOAL]: '',
        [CLIENT_PROFILE_FORM.INVESTMENT_PURPOSE]: '',
        [CLIENT_PROFILE_FORM.INVESTMENT_PURPOSE_OTHERS]: '',
        [CLIENT_PROFILE_FORM.RISK_TOLERANCE]: '',
        [CLIENT_PROFILE_FORM.INVESTMENT_EXP_BONDS_YRS]: '',
        [CLIENT_PROFILE_FORM.INVESTMENT_EXP_BONDS_STRATEGY]: '',
        [CLIENT_PROFILE_FORM.INVESTMENT_EXP_EQUITIES_YRS]: '',
        [CLIENT_PROFILE_FORM.INVESTMENT_EXP_EQUITIES_STRATEGY]: '',
        // [CLIENT_PROFILE_FORM.INVESTMENT_EXP_DERIVATIVES_YRS]: '',
        // [CLIENT_PROFILE_FORM.INVESTMENT_EXP_DERIVATIVES_STRATEGY]: '',
        [CLIENT_PROFILE_FORM.INVESTMENT_EXP_PRIVATE_EQUITY_HEDGE_FUNDS_YRS]: '',
        [CLIENT_PROFILE_FORM.INVESTMENT_EXP_PRIVATE_EQUITY_HEDGE_FUNDS_STRATEGY]: '',
        [CLIENT_PROFILE_FORM.INVESTMENT_EXP_REAL_ESTATE_YRS]: '',
        [CLIENT_PROFILE_FORM.INVESTMENT_EXP_REAL_ESTATE_STRATEGY]: '',
        [CLIENT_PROFILE_FORM.INVESTMENT_EXP_OTHER_ALTERNATIVE_YRS]: '',
        [CLIENT_PROFILE_FORM.INVESTMENT_EXP_OTHER_ALTERNATIVE_STRATEGY]: '',
        [CLIENT_PROFILE_FORM.INDEPENDENT_PROF_ADVICE]: '',
        [CLIENT_PROFILE_FORM.INSIDER_STATUS]: '',
        [CLIENT_PROFILE_FORM.INSIDER_STATUS_LIST]: [{
          id: 'insiderForm-1',
          [CLIENT_PROFILE_FORM.INSIDER_STATUS_LIST_COMPANY]: '',
          [CLIENT_PROFILE_FORM.INSIDER_STATUS_LIST_POSITION]: '',
        }],
        [CLIENT_PROFILE_FORM.INVESTMENT_OBJECTIVE_TIME_HORIZON]: '',
        [CLIENT_PROFILE_FORM.ASSET_CLASSES]: [],
        [CLIENT_PROFILE_FORM.MARKETS]: [],
        [CLIENT_PROFILE_FORM.INVESTMENT_KNOWLEDGE]: '',
        [CLIENT_PROFILE_FORM.RESTRICTIONS]: '',
        // [CLIENT_PROFILE_FORM.OTHER_SECTOR]: '',
        // [CLIENT_PROFILE_FORM.OTHER_ISSUER]: '',
        [CLIENT_PROFILE_FORM.OTHER_RESTRICTION]: '',
      },
    },
    fatcaCrsReducer: {
      fatca: {
        [FATCA.FATCA_Q1]: '',
        [FATCA.FATCA_Q2]: '',
        [`${FATCA.FATCA_Q2}${FATCA.STATE}`]: '',
        [`${FATCA.FATCA_Q2}${FATCA.CITY}`]: '',
        [FATCA.FATCA_Q3]: '',
        [`${FATCA.FATCA_Q3}${FATCA.ADDRESS}`]: '',
        [`${FATCA.FATCA_Q3}${FATCA.US_PHONE}`]: '',
        [FATCA.FATCA_Q4]: '',
        [`${FATCA.FATCA_Q4}${FATCA.ADDRESS}`]: '',
        [FATCA.FATCA_Q5]: '',
        [`${FATCA.FATCA_Q5}${FATCA.BENEFICIARY}`]: '',
        [`${FATCA.FATCA_Q5}${FATCA.NATIONALITY}`]: '',
        [FATCA.FATCA_Q6]: '',
        [`${FATCA.FATCA_Q6}${FATCA.NAME_OF_PERSON}`]: '',
        [`${FATCA.FATCA_Q6}${FATCA.NATIONALITY}`]: '',
        [`${FATCA.FATCA_Q6}${FATCA.ADDRESS}`]: '',
        [`${FATCA.FATCA_Q6}${FATCA.US_PHONE}`]: '',
      },
      crs: {
        [CRS.CRS_Q1]: '',
        [CRS.RESIDENT_REPORTABLE_JURISDICTION]: '',
        [CRS.CRS_Q2]: '',
        [CRS.RESIDENCE_ADDRESS]: '',
        [CRS.CRS_Q3]: '',
        [CRS.TELEPHONE_NUMBER]: '',
        [CRS.CRS_Q4]: '',
        [CRS.HOLD_MAIL]: '',
        [CRS.CRS_Q5]: '',
        [CRS.STANDING_INSTRUCTION]: '',
        [CRS.CRS_Q6]: '',
        [CRS.EFFECTIVE_POA]: '',
      },
      countryTax: [{
        id: 'tax-1',
        [COUNTRY_TAX.COUNTRY_JURISDICTION]: '',
        [COUNTRY_TAX.IS_TIN]: '',
        [COUNTRY_TAX.TIN]: '',
        [COUNTRY_TAX.REASON_OPTION]: '',
        [COUNTRY_TAX.REASON_TIN_NOT_ISSUED]: '',
      }],
    },
  },
  agreementReducer: {
    [AGREEMENT.AOF_KYC]: {
      selected: [],
      agreements: [
        { id: 'AGREE-AOF-KYC-01', label: 'agreements.aofKyc.option1', isChecked: false },
        { id: 'AGREE-AOF-KYC-02', label: 'agreements.aofKyc.option2', isChecked: false },
        { id: 'AGREE-AOF-KYC-03', label: 'agreements.aofKyc.option3', isChecked: false },
      ],
    },
    [AGREEMENT.PROFILE]: {
      selected: [],
      agreements: [
        { id: 'AGREE-PROFILE-01', label: 'agreements.profile.option1', isChecked: false },
        { id: 'AGREE-PROFILE-02', label: 'agreements.profile.option2', isChecked: false },
      ],
    },
    [AGREEMENT.NDPF]: false,
    [AGREEMENT.PROPOSED_PLAN]: false,
    [AGREEMENT.AOF_KYC_PROFILE_SIGNATURE]: '',
    [AGREEMENT.NDPF_PROPOSED_PLAN_SIGNATURE]: '',
    [AGREEMENT.AOF_KYC_PROFILE_TIMESTAMP]: '',
    [AGREEMENT.NDPF_PROPOSED_PLAN_TIMESTAMP]: '',
    [AGREEMENT.AOF_KYC_PROFILE_TIMESTAMP_UTC]: '',
    [AGREEMENT.NDPF_PROPOSED_PLAN_TIMESTAMP_UTC]: '',
    [AGREEMENT.IS_AGREEMENT_READY_FOR_QUALIFIED]: false,
    [AGREEMENT.IS_CUSTOM_AA_UPLOADED]: false,
  },
};

/* eslint-disable no-underscore-dangle */
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
// const composeEnhancers = process.env.NODE_ENV === 'production' ? compose : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
/* eslint-enable */

const store = createStore(
  rootReducer,
  initialState,
  composeEnhancers(
    applyMiddleware(
      thunkMiddleware,
    ),
  ), persistedState,
);

store.subscribe(throttle(() => {
  localState.saveState({
    language: store.getState().languageReducer,
    auth: store.getState().authReducer,
    formOptions: store.getState().formOptionReducer,
    refCode: store.getState().applicantRootReducer.applicantReducer.imarkazRefCode,
    latestRefCode: store.getState().applicantRootReducer.applicantReducer.latestRefCode,
    productCode: store.getState().applicantRootReducer.applicantReducer.productCode,
    catalog: store.getState().catalogueReducer.data,
  });
}, 1000));

export default store;
